import axios from 'src/api/Api';
import {
    SET_CALENDAR_SETTINGS_SUCCESS,
    SET_CALENDAR_SETTINGS_FAILURE,
    IS_SETTING_PAGE_UPDATE,
    IS_GENERATED_LINK_UPDATE,
} from '../actions';
import { put } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export default function* setCalendarSettings(action) {
    const { isTurnOnCalendarSharing, reqBody } = action.payload;
    const url = `occ/v2/${localStorage.getItem('baseSiteId')}/orders/userpreferences`;
    try {
        const result = yield axios
            .put(url, reqBody)
            .then((response) => response.data);
        yield put({ type: SET_CALENDAR_SETTINGS_SUCCESS, payload: result });
        if (!isTurnOnCalendarSharing) {
            yield put({
                type: IS_SETTING_PAGE_UPDATE,
                payload: { isSettingPageUpdate: true, newLinkData: {} },
            });
        } else {
            yield put({
                type: IS_GENERATED_LINK_UPDATE,
                payload: { isGeneratedLinkUpdate: true },
            });
        }
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({
            type: SET_CALENDAR_SETTINGS_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}
